var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t("groupBy"),
      _vm._v(" "),
      _vm._t("pagination"),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c(
          "div",
          { staticClass: "btn-group", staticStyle: { margin: "auto" } },
          _vm._l(_vm.chartModeOptions, function (option) {
            return _c(
              "button",
              {
                key: option,
                class: [
                  "btn btn-default btn-sm",
                  { active: _vm.chartMode === option },
                ],
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    _vm.chartMode = option
                  },
                },
              },
              [_vm._v(_vm._s(option))]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("table", { staticClass: "group-table" }, [
        _c("thead", [
          _c(
            "tr",
            { staticClass: "rounded" },
            _vm._l(_vm.headers, function (header, i) {
              return _c(
                "th",
                {
                  key: header.id,
                  style: {
                    width: header.isBar ? "60%" : undefined,
                  },
                  attrs: { title: header.title },
                },
                [
                  i === 0
                    ? _c(
                        "v-popover",
                        {
                          staticStyle: { display: "inline-block" },
                          attrs: { offset: "5" },
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                role: "button",
                                title: "Column meanings",
                              },
                            },
                            [
                              _c("span", {
                                staticClass: "fa fa-lg fa-question-circle",
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("template", { slot: "popover" }, [
                            _c(
                              "table",
                              {
                                staticClass: "table table-condensed",
                                staticStyle: {
                                  "table-layout": "auto",
                                  "max-width": "calc(100vw - 75px)",
                                  width: "500px",
                                },
                              },
                              [
                                _c(
                                  "tbody",
                                  _vm._l(_vm.definitions, function (row, i) {
                                    return _c(
                                      "tr",
                                      { key: i },
                                      _vm._l(row, function (cell, j) {
                                        return _c("td", { key: j }, [
                                          _vm._v(_vm._s(cell)),
                                        ])
                                      }),
                                      0
                                    )
                                  }),
                                  0
                                ),
                              ]
                            ),
                          ]),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  header.sortProp
                    ? _c(
                        "a",
                        {
                          class: ["sort", { disabled: _vm.disabled }],
                          attrs: {
                            role: "button",
                            title: header.title + " (click to sort)",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.changeSort(header.sortProp)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(header.label) +
                              "\n\t\t\t\t\t"
                          ),
                        ]
                      )
                    : [_vm._v(_vm._s(header.label))],
                ],
                2
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm._l(_vm.rows, function (row) {
              return [
                _c(
                  "tr",
                  {
                    key: row.id,
                    staticClass: "grouprow rounded interactable",
                    on: {
                      click: function ($event) {
                        return _vm.openPreviewConcordances(row.id)
                      },
                    },
                  },
                  _vm._l(_vm.columns, function (col) {
                    return _c(
                      "td",
                      { key: col.toString() },
                      [
                        typeof col === "string"
                          ? [
                              col.indexOf("relative") === -1
                                ? [
                                    _vm._v(
                                      _vm._s(
                                        row[col] != null
                                          ? row[col].toLocaleString()
                                          : "[unknown]"
                                      )
                                    ),
                                  ]
                                : [
                                    _vm._v(
                                      _vm._s(
                                        row[col] != null
                                          ? _vm.$options.filters.frac2Percent(
                                              row[col]
                                            )
                                          : "[unknown]"
                                      )
                                    ),
                                  ],
                            ]
                          : _c(
                              "div",
                              { staticClass: "progress group-size-indicator" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "progress-bar progress-bar-primary",
                                    style: {
                                      "min-width": row[col[0]]
                                        ? _vm.$options.filters.frac2Percent(
                                            row[col[0]] / _vm.maxima[col[0]]
                                          )
                                        : "100%",
                                      opacity: row[col[0]] ? 1 : 0.5,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        row[col[1]]
                                          ? row[col[1]].toLocaleString()
                                          : "[unknown]"
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                      ],
                      2
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.concordances[row.id] && _vm.concordances[row.id].open
                  ? _c(
                      "tr",
                      {
                        key: row.id + "-concordances",
                        staticClass: "concordance",
                      },
                      [
                        _c("td", { attrs: { colspan: "10" } }, [
                          _c(
                            "div",
                            { staticClass: "well-light" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "concordance-controls clearfix",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-sm btn-primary open-concordances",
                                      attrs: {
                                        type: "button",
                                        disabled: _vm.disabled,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openFullConcordances(
                                            row.id,
                                            row.displayName
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "fa fa-angle-double-left",
                                      }),
                                      _vm._v(" View detailed concordances"),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  !_vm.allConcordancesLoaded(row.id)
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-sm btn-default",
                                          attrs: {
                                            type: "button",
                                            disabled: !_vm.canLoadConcordances(
                                              row.id
                                            ),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.loadPreviewConcordances(
                                                row.id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm.concordances[row.id].request !=
                                          null
                                            ? [
                                                _c("span", {
                                                  staticClass:
                                                    "fa fa-spin fa-spinner",
                                                }),
                                                _vm._v(
                                                  " Loading...\n\t\t\t\t\t\t\t\t\t"
                                                ),
                                              ]
                                            : [
                                                _vm._v(
                                                  "Load more concordances"
                                                ),
                                              ],
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "close close-concordances",
                                      attrs: { type: "button", title: "close" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openPreviewConcordances(
                                            row.id
                                          )
                                        },
                                      },
                                    },
                                    [_c("span", [_vm._v("×")])]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.concordances[row.id].error != null
                                ? _c("div", { staticClass: "text-danger" }, [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.concordances[row.id].error
                                        ),
                                      },
                                    }),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.type === "hits" &&
                              _vm.concordances[row.id].concordances.length > 0
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "clearfix",
                                        staticStyle: {
                                          "border-bottom": "1px solid #ddd",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-xs-5 text-right",
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(_vm._s(_vm.leftLabel)),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._m(0, true),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "col-xs-5" }, [
                                          _c("strong", [
                                            _vm._v(_vm._s(_vm.rightLabel)),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.concordances[row.id].concordances,
                                      function (conc, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "clearfix concordance",
                                          },
                                          [
                                            _vm.concordanceAsHtml
                                              ? [
                                                  _c("div", {
                                                    staticClass:
                                                      "col-xs-5 text-right",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        conc.left
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-2 text-center",
                                                    },
                                                    [
                                                      _c("strong", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            conc.hit
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("div", {
                                                    staticClass: "col-xs-5",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        conc.right
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              : [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-5 text-right",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "… " + _vm._s(conc.left)
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-2 text-center",
                                                    },
                                                    [
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(conc.hit) + " "
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-xs-5" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(conc.right) +
                                                          " …"
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                          ],
                                          2
                                        )
                                      }
                                    ),
                                  ]
                                : _vm.type === "docs" &&
                                  _vm.concordances[row.id].concordances.length >
                                    0
                                ? [
                                    _c("table", [
                                      _c("thead", [
                                        _c("tr", [
                                          _c(
                                            "th",
                                            { staticStyle: { width: "80%" } },
                                            [_vm._v("Document")]
                                          ),
                                          _vm._v(" "),
                                          _vm.concordances[row.id].hasHits
                                            ? _c(
                                                "th",
                                                {
                                                  staticStyle: { width: "20%" },
                                                },
                                                [_vm._v("Hits")]
                                              )
                                            : _vm._e(),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "tbody",
                                        _vm._l(
                                          _vm.concordances[row.id].concordances,
                                          function (conc, index) {
                                            return _c("tr", { key: index }, [
                                              _c("td", [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href: conc.href,
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(conc.title))]
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _vm.concordances[row.id].hasHits
                                                ? _c("td", [
                                                    _c("strong", [
                                                      _vm._v(_vm._s(conc.hits)),
                                                    ]),
                                                  ])
                                                : _vm._e(),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                    ]),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]
            }),
          ],
          2
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-xs-2 text-center", staticStyle: { padding: "0" } },
      [_c("strong", [_vm._v("Hit")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }